var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    opacity: 0.496,
    cx: 24,
    cy: 24,
    r: 23.5
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12h24v24H12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.543 18.498C34 20.28 34 24 34 24s0 3.72-.457 5.502c-.254.985-.997 1.76-1.938 2.022C29.896 32 24 32 24 32s-5.893 0-7.605-.476c-.945-.266-1.687-1.04-1.938-2.022C14 27.72 14 24 14 24s0-3.72.457-5.502c.254-.985.997-1.76 1.938-2.022C18.107 16 24 16 24 16s5.896 0 7.605.476c.945.266 1.687 1.04 1.938 2.022zM22 27.5l6-3.5-6-3.5v7z",
    fill: "#FFF",
    fillRule: "nonzero"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYt);
export default __webpack_public_path__ + "static/media/ic-YT.fc819d05dd075fea0dec6cac1b6a070b.svg";
export { ForwardRef as ReactComponent };